<template>
  <div>
    <h3 class="mb-4">Kontroller verdibevis</h3>
    <p class="mt-3 lead" v-if="invoice_details_count === 0">
      For å løse inn verdibevis og få betalt, må verdibeviset være gyldig. Gyldige verdibevis kan
      løses inn i tre steg.
    </p>
    <p class="font-weight-bold">1. Sjekk verdibevisets gyldighet:</p>
    <b-form>
      <div v-if="showScanner">
        <b-button tabindex="-1" @click="showScanner = false" variant="danger">
          <i class="fa fa-qrcode"></i> Steng scanner
        </b-button>
        <div class="scanner-wrapper">
          <qrcode-stream class="stream" @decode="onDecode"></qrcode-stream>
        </div>
      </div>
      <div v-else>
        <b-form @submit.prevent="submit">
          <b-form-group
            label-for="code"
            :description="
              voucherError.length === 0 && giftcards.length === 0
                ? 'Oppgi kundens 12-sifrede verdibevisnummer'
                : ''
            "
          >
            <vue-bootstrap-typeahead
              v-model="code"
              :data="searchResults"
              :input-class="`${voucherError.length ? 'is-invalid' : ''}`"
              size="lg"
              placeholder="123456789012"
              :serializer="item => ''+item.code"
              @hit="setCode"
              @input="resetErrors()"
            >
              <template slot="append">
                <b-button tabindex="-1" @click="showScanner = true" variant="outline-primary"
                  ><i class="fa fa-qrcode"></i
                ></b-button>
              </template>
              <template slot="suggestion" slot-scope="{ data, htmlText }">
                <div class="">
                  <span v-html="htmlText"></span><br />
                  <small>{{ data.product_variation.product.name }}</small>
                </div>
              </template>
            </vue-bootstrap-typeahead>
            <div
              class="invalid-feedback"
              :style="{ display: voucherError.length ? 'block' : 'none' }"
            >
              {{ voucherError }}
            </div>
            <div
              class="valid-feedback"
              :style="{ display: giftcards.length ? 'block' : 'none' }"
            >
              Verdibeviset er gyldig og kan løses inn.
            </div>
          </b-form-group>
          <b-button type="submit" variant="primary" block class="text-uppercase"
            >Sjekk gyldighet</b-button
          >
        </b-form>
      </div>
    </b-form>
    <p class="mt-3" v-if="invoice_details_count > 0">
      <small class="text-muted">
        For å løse inn verdibevis og få betalt, må verdibeviset være gyldig. Gyldige verdibevis kan
        løses inn i tre steg.
      </small>
    </p>
  </div>
</template>

<script>
import { giftcard } from '@/api';
import { QrcodeStream } from 'vue-qrcode-reader';
import { mapGetters, mapMutations } from 'vuex';
import VueBootstrapTypeahead from '@/components/typeahead/Typeahead.vue';

export default {
  components: {
    QrcodeStream,
    VueBootstrapTypeahead,
  },
  data() {
    return {
      code: '',
      showScanner: false,
      searchResults: [],
    };
  },
  computed: {
    ...mapGetters({
      voucherError: 'vouchers/error',
      invoice_details_count: 'vouchers/invoice_details_count',
      giftcards: 'vouchers/giftcards',
    }),
  },
  methods: {
    ...mapMutations({
      resetErrors: 'vouchers/reset_errors',
    }),
    onDecode(code) {
      this.code = code;
      this.showScanner = false;
      this.submit();
    },
    submit() {
      this.$emit('pressed-activate', this.code.replace(/\s/g, ''));
    },
    async searchForCode() {
      const res = await giftcard.validate(this.code, true)
      this.searchResults = [res.data[0]];
    },
    setCode(code) {
      this.code = code.code;
      this.submit();
    },
  },
  watch: {
    code: function(val) {
      if (val.length > 4 && val.length < 12) {
        this.searchForCode();
      } else {
        this.searchResults = [];
      }
    },
  },
};
</script>

<style>
.scanner-wrapper {
  background: #000;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.stream {
  padding-top: 0px !important;
  max-width: 300px;
}

.input-group .was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none !important;
}
</style>
